import React from 'react';
import styles from './questionAnswers.css';
import {
    BULLET_LIST_TYPE,
    LETTER_LIST_TYPE,
    NUMBER_LIST_TYPE
} from './constants';
import OptionIcon
    from '../../../../../../../pages/manager/pages/quizPage/editor/components/preview/components/questionsPreview/components/textPollQuestion/components/answers/components/optionIcon/OptionIcon';
import ResultTextPollQuestion from './components/ResultTextPollQuestion';
import { useSelector } from 'react-redux';
import { getSwitchClassNameOrColourWithBackground } from '../../../../../../../utils/func';

/**
 *
 * @type {React.NamedExoticComponent<{readonly calendar?: {settings?: *}, readonly handleAnswerSelection?: *, readonly showTextPollQuestionResult?: *, readonly answers?: *, readonly question?: *, readonly statistics?: *}>}
 */
const QuestionAnswers = React.memo( ( { question, question: { localization }, answers, statistics, handleAnswerSelection, showTextPollQuestionResult, calendar: { settings } } ) => {
    const { localization: { content } } = useSelector( state => state );
    const bulletType = question.list_type === BULLET_LIST_TYPE;
    const numberType = question.list_type === NUMBER_LIST_TYPE;
    const letterType = question.list_type === LETTER_LIST_TYPE;
    const backgroundColorOptionIcon = getSwitchClassNameOrColourWithBackground( settings.appearance.background_color, 'rgba(0, 0, 0, 0.4)', 'rgba(10, 10, 10, 0.3)' );
    const isImagePositionCover = question.localization.image_position === 'cover';
    const textAutoColorClass = isImagePositionCover ?  'darkBgPlaceholder' :  getSwitchClassNameOrColourWithBackground( settings.appearance.background_color, 'lightBgPlaceholder', 'darkBgPlaceholder' );

    return (
        <div className={ styles.wrapper }
             style={ { maxHeight: showTextPollQuestionResult ? '65%' : '100%' } }
        >
            <div className={ styles.scroll }>
                {
                    showTextPollQuestionResult && statistics && !statistics.questionStatistics.questionSkipped
                        ?
                        <React.Fragment>
                            <ResultTextPollQuestion
                                question={ question }
                                responseAnswersQuestion={ statistics.questionStatistics }
                                settings={ settings }
                            />
                        </React.Fragment>
                        :
                        <div className={ styles.itemListWrap }>{
                            answers
                                .sort( ( elmOme, elemTwo ) => elmOme.id - elemTwo.id )
                                .map( ( item, i ) => {
                                    const answer = item;
                                    return (
                                        <div
                                            className={ styles.questionWrap }
                                            key={ i }

                                            onClick={ () =>
                                                handleAnswerSelection( {
                                                    question_localization_id: localization.id,
                                                    id: answer.id,
                                                    user_answer: answer.id,
                                                    type: localization.answer_model
                                                } )
                                            }>
                                            <div key={ i } className={ styles.optionIconWrapper }>
                                                <OptionIcon
                                                    keyNumber={ i }
                                                    bulletType={ bulletType }
                                                    numberType={ numberType }
                                                    letterType={ letterType }
                                                    elementStyle={ { backgroundColor: backgroundColorOptionIcon } }
                                                />
                                            </div>
                                            <p className={ styles.question }>{ answer.text }</p>
                                        </div>
                                    );
                                } )
                        }
                            <button className={ `${ styles.skipBtn } ${ styles[ textAutoColorClass ] }` }
                                aria-label={ content.skip_question_aria_label }
                                    onClick={ () =>
                                        handleAnswerSelection( {

                                            questionSkipped: true,
                                            question_localization_id: localization.id,
                                            type: localization.answer_model
                                        } )
                                    }>
                                { content.registration.skip || 'Skip' }
                            </button>
                        </div> }

            </div>

        </div>
    );
} );

export default QuestionAnswers;

